<template>
    <footer class="footer">
        <div class="footer__inner">
            <template v-if="type === 'signin'">
                <h3 class="footer__heading">
                    Already have an
                    <span>{{ configStrings.clubName }} {{ configStrings.productName }}</span>?
                </h3>
                <router-link
                    class="buffer-bottom"
                    to="/"
                >Sign in here</router-link>
                <p>
                    Having problems or want help with your
                    <strong>{{ configStrings.clubName }}
                        {{ configStrings.productName }}</strong>?
                </p>
                <a :href="helpURL">Account help</a>
            </template>

            <template v-else-if="type === 'help'"> </template>
            <div class="footer-sponsors">
                <div class="footer-sponsors__row">
                    <h3 class="footer-sponsors__row-title">Principal Partners</h3>
                    <ol class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--large">
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--large">
                            <a
                                href="https://www.adidas.co.uk/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/d8770fa0-1df1-11ef-bbfa-1dc9799b621a.png');
                "
                            >
                            </a>
                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--large">
                            <a
                                href="https://www.betano.com/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/a4dc9ca0-1df1-11ef-bbfa-1dc9799b621a.png');
                "
                            >
                            </a>
                        </li>
                        <!-- <li class="footer-sponsors__sponsor footer-sponsors__sponsor--large">
                            <a
                                href="https://castore.com/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/50fab800-dff6-11ec-a442-f7825cfd5537.png');
                "
                            >
                            </a>
                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--large">
                            <a
                                href="https://bk8.com/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/bdd71a50-1046-11ee-bc1b-c9d9750f32bd.png');
                "
                            >
                            </a>
                        </li> -->
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--large">
                            <a
                                href="https://tradenation.com/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/583a6cd0-10d0-11ee-bf5c-69625bf8a938.png');
                "
                            >
                            </a>
                        </li>
                    </ol>
                </div>
                <div class="footer-sponsors__row">
                    <h4 class="footer-sponsors__row-title">Official Partners</h4>
                    <ol class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--small">
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="http://www.aston.ac.uk/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/9c74cb40-3c8c-11eb-af57-83f725cb3f63.png');
                "
                            >
                            </a>
                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://www.cadbury.co.uk/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/964d8710-0d88-11ed-a78d-5b6a837867ff.png');
                "
                            >
                            </a>

                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://www.carlsbergmarstons.co.uk/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://img.gc.avfcservices.co.uk/fit-in/400x400/a88bf150-322f-11ef-a496-214adf44b783.png');
                "
                            >
                            </a>

                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://www.corpay.com"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/9e9427f0-5213-11ee-8f07-f36f53600d0e.png');
                "
                            >
                            </a>

                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://emmieragroup.com/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/70963ad0-2b91-11ee-8615-f3b74d3f6fb4.png');
                "
                            >
                            </a>

                        </li>
                        <!-- <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://duelbits.com/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/5b002530-18ca-11ed-946a-d75effc8a553.png');
                "
                            >
                            </a>
                        </li> -->
                    </ol>
                </div>
                <div class="footer-sponsors__row">
                    <ol class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--small">
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="'https://shop.avfc.co.uk/en/'"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/42e28060-4f46-11ef-b119-f5996cfcbea7.png');
                "
                            >
                            </a>

                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="'https://www.jdsports.co.uk/club/aston-villa/'"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/f9ba0430-4f45-11ef-b119-f5996cfcbea7.png');
                "
                            >
                            </a>

                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://www.monsterenergy.com"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/865cfae0-0198-11ec-bff3-cf730f19ba24.png');
                "
                            >
                            </a>

                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://www.seatgeek.com"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('/SeatGeek.png');
                "
                            >
                            </a>

                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://www.socios.com/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/98be6ab0-fa91-11eb-a5d7-0f4867f34495.png');
                "
                            >
                            </a>
                        </li>
                    </ol>
                </div>
                <div class="footer-sponsors__row">
                    <h4 class="footer-sponsors__row-title">Charity Partners</h4>
                    <ol class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--small">
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://www.acorns.org.uk/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/5d698df0-0daf-11ed-b697-d911feda48ed.png');
                "
                            >
                            </a>
                        </li>
                        <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small">
                            <a
                                href="https://www.bch.org.uk/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/705d1620-0daf-11ed-b697-d911feda48ed.png');
                "
                            >
                            </a>
                        </li>
                    </ol>
                </div>
            </div>
            <div class="legalLinks">
                <a href="https://www.avfc.co.uk/club/legal/privacy-policy">Privacy Policy</a>
            </div>
            <div class="legalLinks">
                This website is © {{ configStrings.clubName }} {{ year }}. All rights
                reserved
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "FooterShout",
    data() {
        var d = new Date();
        return {
            helpURL: "https://www.avfc.co.uk/fans/digital-membership",
            year: d.getFullYear(),
        };
    },
    props: {
        type: {
            type: String, // register | signin | help
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.footer {
    position: relative;
    margin: 50px 0 0;
    padding: 60px 20px 80px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    background-color: #322024;

    &:before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: transparent url("../assets/stadium-white-out@2x.png") center right no-repeat;
        background-size: cover;
        opacity: 0.4;
        z-index: 1;
    }

    &__inner {
        position: relative;
        z-index: 3;
    }

    &__heading {
        margin: 0 0 24px;
        font-size: 32px;
        font-weight: 300;

        >span {
            font-weight: 500;
        }
    }

    a {
        color: #fff;

        &:hover {
            color: #660033;
        }
    }

    &__telephone {
        margin: 10px 0 0;
        font-size: 34px;
        font-weight: 300;
    }
}

.buffer-bottom {
    display: inline-block;
    margin-bottom: 30px;
}

.features {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 40px auto 0;
    padding: 0;
    max-width: 1200px;
    list-style: none;

    &__item {
        flex-grow: 1;
        flex-basis: 0;
        margin: 0 20px 30px;
        font-size: 15px;
        font-style: normal;
        font-weight: normal;
        line-height: 1.47;
        text-align: center;

        span {
            display: block;
        }

        &:before {
            content: "";
            display: block;
            margin: 0 auto 10px;
            height: 97px;
            width: 97px;
            background-color: rgba(255, 255, 255, 0.75);
            background-position: 50%;
            background-repeat: no-repeat;
            border: 2px solid #fff;
            border-radius: 50%;
        }

        &--store:before {
            background-image: url("../assets/features/retail.svg");
            background-size: 62px;
            background-position: 50% 45%;
        }

        &--plus:before {
            background-image: url("../assets/features/villa-plus.svg");
            background-size: 62px;
            background-position: 50% 45%;
        }

        &--live:before {
            background-image: url("../assets/features/villa-live.svg");
            background-size: 62px;
            background-position: 50% 45%;
        }

        &--app:before {
            background-image: url("../assets/features/app.svg");
            background-size: 62px;
        }

        &--ticketing {
            opacity: 0.5;

            &:before {
                background-image: url("../assets/features/tickets.svg");
                background-size: 62px;
            }
        }
    }
}

.legalLinks {
    margin-top: 20px;
    font-size: 1rem;
}

.footer-sponsors {
    // background-color: footerSetting(footer_sponsors-background_color);

    &__inner {
        max-width: 1440px;
        margin: 0 auto;
        padding-top: 26px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        @media screen and (min-width: 760px) {
            padding-bottom: 8px;
        }
    }

    &__row {
        width: 100%;
    }

    &__row-title {
        // color: footerSetting(footer_sponsors-text_color);
        text-align: center;
    }

    &__sponsor-wrapper {
        margin: 0 auto;
        list-style-type: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        padding-left: 0;

        &--small {
            justify-content: center;

            @media screen and (min-width: 760px) {
                max-width: 720px;
            }

            @media screen and (min-width: 1024px) {
                max-width: 1032px;
            }
        }

        &--large {
            padding-bottom: 16px;
            justify-content: center;

            @media screen and (min-width: 760px) {
                padding-bottom: 12px;
            }

            @media screen and (min-width: 1024px) {
                max-width: 1032px;
                padding-bottom: 0;
            }
        }
    }

    &__sponsor {
        display: flex;
        align-items: center;

        &--small {
            width: 80px;
            height: 80px;
            margin: 0 12px 24px;

            @media screen and (min-width: 760px) {
                width: 96px;
                height: 96px;
            }

            @media screen and (min-width: 1024px) {
                margin: 0 26px 24px;
            }
        }

        &--large {
            width: 132px;
            height: 132px;
            margin: 0 12px 24px;

            @media screen and (min-width: 375px) {
                width: 160px;
                height: 160px;
            }

            @media screen and (min-width: 760px) {
                margin: 0 20px 32px;
            }

            @media screen and (min-width: 1024px) {
                margin: 0 22px 28px;
            }
        }
    }

    &__logo {
        display: block;
        height: 100%;
        width: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
}
</style>
